<template>
  <section class="notfound">
    <p class="code">404</p>
    <h1>{{ t("Cette page n'existe pas.", "This page doesn't exist.") }}</h1>
    <p class="lead">{{ t("Elle a peut-être été déplacée. Revenez à l'accueil pour continuer.", "It may have moved. Head back home to keep exploring.") }}</p>
    <p class="back">
      <router-link class="btn dark" :to="to('home')">{{ t("Retour à l'accueil", "Back to home") }}</router-link>
    </p>
  </section>
</template>

<script>
import { useI18n } from "@/i18n";

export default {
  name: "NotFound",
  setup: () => useI18n(),
};
</script>

<style scoped>
.back {
  margin-top: 24px;
  display: inline-flex;
}
</style>
